import Item from './item'

export default class SetItem extends Item {
  constructor (game, stack) {
    super(game, stack, 'item_set')

    this.instructionName = 'SET'
    this.operands = ['ADDR', 'A']
  }

  _activate () {
    const addr = this.stack.pop()
    const value = this.stack.pop()
    this.stack.push(addr)
    this.stack.memory.setIndirect(this.stack.pointerY, this.stack.pointerX, value)
    this.stack.pop()
  }
}
